import { useState, useEffect } from 'react';

import SelectContent from './select-content';

export default ({ items, placeholder = 'Select something', value = null, onChange }) => {
    const [ clicked, setClicked ] = useState(false);
    const [ selected, setSelected ] = useState(null);

    const onSelect = (item) => {
        setSelected(item);
        onChange(item);
        setClicked(false);
    }

    const onReset = () => {
        setSelected(null);
        setClicked(false);
        onChange({
            option: '',
            value: '',
        })
    }

    const mouseIn = () => setClicked(true);

    const mouseOut = () => setClicked(false);

    useEffect(() => {
        if (value !== null) {
            if (typeof value == 'string') {
                const index = items.find((item) => item.value == value);

                setSelected(index);
            }

            if (typeof value == 'number') {
                setSelected(items[value])
            }
        }
    }, [])

    return (
        <div className="select-dropdown__outer">
            <div className="select-dropdown2" onMouseEnter={mouseIn} onMouseLeave={mouseOut}>
                <div className="select-dropdown__select2">
                    { selected ? selected.option : placeholder } 
                    <img className={clicked ? 'select-dropdown__arrow select-dropdown__arrow--toggled' : 'select-dropdown__arrow' } src='/images/select-arrow.svg'/>
                </div>

                { clicked && <SelectContent content={items} selected={selected} onReset={onReset} onSelect={onSelect}/> }
            </div>
        </div>
    )
}